import { Component, OnInit } from '@angular/core';
import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';
import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';
import { WindowService } from 'src/shared/providers/window.service';
import { Util } from 'src/shared/util/util';
import { TidyStorage } from 'src/shared/providers/tidy-storage';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import { Pros } from 'src/providers/pros/pros';

import { TranslationPipe } from 'src/shared/pipes/translation.pipe';

@Component({
    templateUrl: 'my-pro-settings.html',
    standalone: false
})

export class MyProSettingsPage implements OnInit {

  dialogParams: any;
  bookingDetail: any;
  cardDetail: any;
  jobId: any;
  addressId: any;
  maxJobsForm: UntypedFormGroup;
  pro: any;
  autoPayMaxAmount: number;
  allowsInvoiceAutopay: boolean;

  constructor(
    private navCtrl: CustomNavController,
    private rightSidePanelService: RightSidePanelService,
    public windowService: WindowService,
    private util: Util,
    private storage: TidyStorage,
    private fb: UntypedFormBuilder,
    private pros: Pros
  ) {
    this.maxJobsForm = this.fb.group({
      limitMaxJobs: [false],
      maxJobs: ['', Validators.required],
    });
  }

  async ngOnInit() {
    this.dialogParams = await this.storage.retrieve('dialog-params');
    this.pro = await this.getParam('pro');
    this.rightSidePanelService.setDialogPageTitle(`${this.pro?.homekeeper?.name} ${new TranslationPipe().transform('Settings')}`);
    const maxJobSettings = await this.getParam('maxJobSettings');
    this.maxJobsForm.patchValue(maxJobSettings);
    this.watchMaxJobsFormChanges();
  }

  async getParam(paramName): Promise<any> {
    let param = this.dialogParams?.[paramName];
    if (param === null || param === undefined) {
      param = this.navCtrl.getParam(paramName)
    }
    if (param === null || param === undefined) {
      param = await this.storage.retrieve(paramName);
    }
    return param;
  }

  goToProSettings() {
    if (!this.windowService.isDesktopRes) {
      return this.util.showSuccess(new TranslationPipe().transform('Please log into tidy.com on your desktop to edit autopay settings.'));
    }
    this.navCtrl.navigateForward('pro-settings');
  }

  goToJobRequestWorkflows() {
    this.rightSidePanelService.navigateTo('job-request-workflows');
  }

  limitMaxJobs(): void {
    const limitMaxJobs = this.maxJobsForm.value.limitMaxJobs;
    if (!limitMaxJobs) {
      this.updateMaxJobs(-1);
    }
    this.maxJobsForm.controls.maxJobs.setValue(0);
  }

  watchMaxJobsFormChanges() {
    this.maxJobsForm.valueChanges.pipe(
      debounceTime(1000)
    ).subscribe((value) => {
      if (value.limitMaxJobs) {
        this.updateMaxJobs(Number(value.maxJobs));
      }
    });
  }

  async updateMaxJobs(value: number): Promise<void> {
    try {
      const payload = {
        team_id: this.pro.team.id,
        key: 'max_scheduled_jobs_per_day',
        value,
      }
      await this.pros.updateMaxJobs(payload);
      this.util.showSuccess(new TranslationPipe().transform('Max jobs settings updated successfully'));
    } catch (err) {
      this.util.showError((err.error && err.error.message) ? err.error.message : err.message, 10000);
    }
  }

}
